import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/social/react-instagram/src/instagram-post.tsx");
